"use client";
import "./about_us_slider.scss";
import classnames from "classnames";
import { ReactElement, useState } from "react";
import { Text } from "@/elements/text/text";
import { i18n } from "@/model/i18n";
import { Icon } from "@/elements/icon/icon";
import { Container } from "@/elements/container/container";

const ITEMS = [
  {
    quote: i18n.t("pages.about_us.slider.member_1.quote"),
    author: i18n.t("pages.about_us.slider.member_1.author"),
  },
  {
    quote: i18n.t("pages.about_us.slider.member_2.quote"),
    author: i18n.t("pages.about_us.slider.member_2.author"),
  },
];

export function AboutUsSlider(): ReactElement {
  const [activeItem, setActiveItem] = useState(0);
  const disabledLeft = activeItem === 0;
  const disabledRight = activeItem === ITEMS.length - 1;

  return (
    <section className="about-us-slider" aria-label="about-us-slider">
      <Container>
        <div className="about-us-slider__main">
          <button
            className={classnames(
              "about-us-slider__arrow",
              "about-us-slider__arrow--left",
              {
                "about-us-slider__arrow--disabled": disabledLeft,
              },
            )}
            onClick={() => {
              setActiveItem((item) => {
                return Math.max(item - 1, 0);
              });
            }}
          >
            <Icon
              name="arrow-slider-left"
              size={24}
              color={
                disabledLeft
                  ? "disabled-on-default"
                  : "inverted-pairings-default"
              }
            />
          </button>
          <ul className="about-us-slider__contents">
            {ITEMS.map((item, index) => {
              const isActive = activeItem === index;

              return (
                <li
                  key={item.author}
                  className={classnames("about-us-slider__content", {
                    "about-us-slider__content--active": isActive,
                  })}
                >
                  <Text
                    htmlElement="p"
                    type="h3-regular"
                    color="neutral-on-surface"
                  >
                    {item.quote}
                  </Text>
                  <Text
                    htmlElement="h3"
                    type="sh2-xbold"
                    color="neutral-on-surface"
                  >
                    {item.author}
                  </Text>
                </li>
              );
            })}
          </ul>
          <button
            className={classnames(
              "about-us-slider__arrow",
              "about-us-slider__arrow--left",
              {
                "about-us-slider__arrow--disabled": disabledRight,
              },
            )}
            onClick={() => {
              setActiveItem((item) => {
                return Math.min(item + 1, ITEMS.length - 1);
              });
            }}
          >
            <Icon
              name="arrow-slider-right"
              size={24}
              color={
                disabledRight
                  ? "disabled-on-default"
                  : "inverted-pairings-default"
              }
            />
          </button>
          <ul className="about-us-slider__bullets">
            {ITEMS.map((item, index) => {
              const isActive = activeItem === index;

              return (
                <li
                  key={item.author}
                  className={classnames("about-us-slider__bullet", {
                    "about-us-slider__bullet--active": isActive,
                  })}
                  onClick={() => setActiveItem(index)}
                ></li>
              );
            })}
          </ul>
        </div>
      </Container>
    </section>
  );
}
